import { _request, APIMethod } from '../';

import * as apiTypes from './TenantApiTypeDefs';

const TENANTS_PATH_PREFIX = '/tenants';

export const APITenantGet: APIMethod<
    apiTypes.APITenantGetParams, apiTypes.APITenantGetResponse
> = (
    params: apiTypes.APITenantGetParams
) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.id}`)
);

export const APITenantPost: APIMethod<
    apiTypes.APITenantPostParams, apiTypes.APITenantPostResponse
> = (params) => (
    _request<apiTypes.APITenantPostResponse>('POST', TENANTS_PATH_PREFIX, {
        name: params.name,
        suiteId: params.suiteId,
        isLicenseRequired: params.isLicenseRequired
    })
);

export const APITenantDelete: APIMethod<
    apiTypes.APITenantDeleteParams, apiTypes.APITenantDeleteResponse
> = (params) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.id}`)
);

export const APITenantPut: APIMethod<
    apiTypes.APITenantPutParams, apiTypes.APITenantPutResponse
> = (params: apiTypes.APITenantPutParams) => (
    _request<apiTypes.APITenantPutResponse>('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}`, {
        id: params.tenantId,
        applicationSuiteId: params.suiteId,
        name: params.name,
    })
);
